import { render, staticRenderFns } from "./TheSourcePopover.vue?vue&type=template&id=37ed17b3&"
import script from "./TheSourcePopover.vue?vue&type=script&lang=js&"
export * from "./TheSourcePopover.vue?vue&type=script&lang=js&"
import style0 from "./TheSourcePopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports